$(function() {

	//place
	var shape = {
		coord: [0, 0, 65, 0, 65, 65, 0 ,65],
		type: 'poly'
	};
	var stylez = [
    {
        "featureType": "all",
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#f49f53"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text",
        "stylers": [
            {
                "visibility": "simplified"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "all",
        "stylers": [
            {
                "color": "#f9ddc5"
            },
            {
                "lightness": -7
            }
        ]
    },
    {
        "featureType": "poi.business",
        "elementType": "all",
        "stylers": [
            {
                "color": "#645c20"
            },
            {
                "lightness": 38
            }
        ]
    },
    {
        "featureType": "poi.government",
        "elementType": "all",
        "stylers": [
            {
                "color": "#9e5916"
            },
            {
                "lightness": 46
            }
        ]
    },
    {
        "featureType": "poi.medical",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 38
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "all",
        "stylers": [
            {
                "color": "#645c20"
            },
            {
                "lightness": 39
            }
        ]
    },
    {
        "featureType": "poi.school",
        "elementType": "all",
        "stylers": [
            {
                "color": "#a95521"
            },
            {
                "lightness": 35
            }
        ]
    },
    {
        "featureType": "poi.sports_complex",
        "elementType": "all",
        "stylers": [
            {
                "color": "#9e5916"
            },
            {
                "lightness": 32
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "all",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 43
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#f19f53"
            },
            {
                "weight": 1.3
            },
            {
                "visibility": "on"
            },
            {
                "lightness": 16
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#f19f53"
            },
            {
                "lightness": -10
            }
        ]
    },
    {
        "featureType": "transit",
        "elementType": "all",
        "stylers": [
            {
                "lightness": 38
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "all",
        "stylers": [
            {
                "color": "#813033"
            },
            {
                "lightness": 22
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "all",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "color": "#1994bf"
            },
            {
                "saturation": -69
            },
            {
                "gamma": 0.99
            },
            {
                "lightness": 43
            }
        ]
    }
];

	var openInfoWindow;
	function initMap() {

		var maplist = [];
		var myOptions = {
			navigationControlOptions:
			{

			style: google.maps.NavigationControlStyle.DEFAULT,
			position: google.maps.ControlPosition.RIGHT_TOP

			},
			zoom : 16,
			navigationControl: true,
			center : new google.maps.LatLng(34.666143, 133.917816),
			scrollwheel: false ,
			mapTypeId: google.maps.MapTypeId.ROADMAP
		};
		var map = new google.maps.Map(document.getElementById('map'), myOptions);

		var infowindow = new google.maps.InfoWindow;
		var marker, i;
		var bounds = new google.maps.LatLngBounds();
		for (i = 0; i < locations.length; i++) {
			var image = {
				url : '//nap-dog.com/cdn/shop/t/47/assets/map.png?v=33265027263856391261692345123',
				scaledSize : new google.maps.Size(24, 32),
				labelOrigin: new google.maps.Point(13, -20)
			}
			
			var markerOptions = {
				position: new google.maps.LatLng(locations[i][1], locations[i][2]),
				map: map,
				icon: image,
				label: {
				   text: locations[i][0],
				   color: '#fff',
				   fontFamily: 'sans-serif',
				   fontWeight: 'bold',
				   fontSize: '10px',
					className: "labels"
				}
			  };
			var marker = new google.maps.Marker(markerOptions);
			bounds.extend (marker.position);
			var mapStyleType =  new google.maps.StyledMapType( stylez, {map: map, name:""});



			google.maps.event.addListener(marker, 'click', (function(marker, i) {
				 return function() {
					location.href = locations[i][3];

				 }
			})(marker, i));
			maplist[i] = marker;
		}
		map.mapTypes.set('ablog', mapStyleType);
  		map.setMapTypeId('ablog');
		map.fitBounds (bounds);


		//パラメータ
		function getParam() {
			var url   = location.href;
			parameters    = url.split("?");
			if(parameters.length === 1) return false;
			params   = parameters[1].split("&");
			var paramsArray = [];
			for ( i = 0; i < params.length; i++ ) {
				neet = params[i].split("=");
				paramsArray.push(neet[0]);
				paramsArray[neet[0]] = neet[1];
			}
			var categoryKey = paramsArray["map"];
			return categoryKey;
		}
		if(getParam()) {
			var index = getParam();
			google.maps.event.trigger(maplist[index], "click");
			$('html,body').stop().animate({ scrollTop: $('.exhibition__content').offset().top },500,'easeInOutQuart');
		}

		$(".exhibition__content .map--detail > li > dl > dt").off();
		$(".exhibition__content .map--detail > li > dl > dt").on({'click':function(){
			var index = $('.exhibition__content .map--detail > li > dl > dt').index(this);
			google.maps.event.trigger(maplist[index], "click");
			$('html,body').stop().animate({ scrollTop: $('.exhibition__content').offset().top },500,'easeInOutQuart');
			return false;
		}
		});
	}

	initMap();
});
